import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';
import { mainItemTypeValues } from 'default-settings';
import { isFree, isRentEnabled, isSaleEnabled, isBought, isRented } from 'shared/ui-selectors/video/pricing';


export const BUY_BUTTON_DISPLAY_TYPES = {
  BUY: 'buy',
  RENT: 'rent',
  BUY_FROM: 'from',
  NONE: 'none',
};

export const PLAY_BUTTON_DISPLAY_TYPES = {
  PLAY_VIDEO: 'play-video',
  WATCH_NOW: 'watch-now',
  WATCH_TRAILER: 'watch-trailer',
  WATCH_PREVIEW: 'watch-preview',
  NONE: 'none',
};

export const PLAY_BUTTON_TYPES = {
  PLAY: 'play',
  TRAILER_OR_PREVIEW: 'trailer_or_preview',
};

// Todo: remove. Use widget/ui-selectors/video-access
export function getBuyButtonDisplayTypeWhenInOverlay({ settings, videoItem, channelData, showChannelCover }) {
  // case when user has not yet selected any video
  if (showChannelCover) {
    // only show buy button for featured video or when a video is ended. Otherwise no buy button
    if (mainItemIsChannelCover(settings)) {
      return BUY_BUTTON_DISPLAY_TYPES.NONE;
    }
  }

  return getBuyButtonDisplayType(channelData, videoItem);
}

function canAccessPaidVideo(channelData, videoItem) {
  if (isSubscribedToChannel(channelData) ||
    isRented(videoItem) ||
    isBought(videoItem)) {
    return true;
  }
}

export function canAccessFullVersionOfVideo(channelData, videoItem) {
  return isFree(videoItem) || canAccessPaidVideo(channelData, videoItem);
}

export function getBuyButtonDisplayType(channelData, videoItem) {
  if (canAccessPaidVideo(channelData, videoItem)) {
    return BUY_BUTTON_DISPLAY_TYPES.NONE;
  }

  return getBuyButtonDisplayTypeForPaidVideo(videoItem);
}

export function getBuyButtonDisplayTypeForPaidVideo(videoItem) {
  const _isRentEnabled = isRentEnabled(videoItem);
  const _isSaleEnabled = isSaleEnabled(videoItem);

  if (_isRentEnabled && _isSaleEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.BUY_FROM;
  } else if (_isSaleEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.BUY;
  } else if (_isRentEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.RENT;
  }

  return BUY_BUTTON_DISPLAY_TYPES.NONE;
}

// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
export function shouldShowSubscribeButton({ settings, videoItem, channelData, showChannelCover }) {
  const hasChannelSubscription = isSubscribedToChannel(channelData);

  return (
    hasSubscriptionPriceInfo(channelData) &&
    !hasChannelSubscription &&
    (
      (
        !hasChannelSubscription && shouldShowChannelCover(settings, showChannelCover)
      ) || (
        channelData.subscriptionOnly &&
        !isFree(videoItem) && !isRented(videoItem) && !isBought(videoItem)
      )
    )
  );
}

export function mainItemIsChannelCover(settings) {
  return settings.numbers.mainItemType === mainItemTypeValues.CHANNEL_COVER;
}

export function shouldShowChannelCover(settings, showChannelCover) {
  return showChannelCover && mainItemIsChannelCover(settings);
}

// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
export function getPlayButtonType(channelData, videoItem) {
  if (canAccessFullVersionOfVideo(channelData, videoItem)) {
    return PLAY_BUTTON_TYPES.PLAY;
  }
  return PLAY_BUTTON_TYPES.TRAILER_OR_PREVIEW;
}

function hasSubscriptionPriceInfo(channelData) {
  return channelData && Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channelData.dealInfo));
}

export function isSubscribedToChannel(channelData) {
  return _.has(channelData, 'dgsInfo.subscription');
}



// WEBPACK FOOTER //
// ./src/widget/utils/overlay-buttons-utils.js